import { inject, injectable } from '@patsnap/tahiti-core/shared/inversify';
import type { GetTaskIdDTO } from '@/services/history/service/history.repository.interface.ts';
import { GetTaskId } from '@/infrastructure/api-functions/interface/get-task-id.interface';

@injectable()
export class GetTaskIdDTOImpl implements GetTaskIdDTO {
    constructor(
        @inject(GetTaskId)
        private readonly _getTaskIdApi: GetTaskId
    ) {
    }

    async fetch(type: string): Promise<string> {
        return await this._getTaskIdApi.getTaskId({ type });
    }
}
